import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HeroSection from "pages/hero-section";
import AboutSection from "pages/about-section";
import FooterSectionPage from "pages/footer-section";
import ContactSection from "pages/contact-section";
import PortfolioShowcase from "pages/portfolio-showcase";
import TestimonialsSection from "pages/testimonials-section";
import TermsPage from "pages/legal/TermsPage";
import PoliciesPage from "pages/legal/PoliciesPage";

const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here */}
          <Route path="/" element={<HeroSection />} />
          <Route path="/hero-section" element={<HeroSection />} />
          <Route path="/about-section" element={<AboutSection />} />
          <Route path="/footer-section" element={<FooterSectionPage />} />
          <Route path="/contact-section" element={<ContactSection />} />
          <Route path="/portfolio-showcase" element={<PortfolioShowcase />} />
          <Route path="/testimonials-section" element={<TestimonialsSection />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PoliciesPage />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
        <FooterSectionPage />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
